export type InitLoaderConfig = {
  fetch?: boolean;
};

export async function initLoader(config?: InitLoaderConfig): Promise<void> {
  if (config?.fetch) {
    try {
      await fetchInit();
    } catch (e) {
      console.error(`Caught fetch rejection: ${e}`);
    }
  }
  clickSubmitButton();
}

async function fetchInit(): Promise<Response> {
  const mainForm = document.querySelector("#mainForm") as HTMLFormElement;
  return fetch(mainForm.action, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: "_eventId=initiateLoader&ajaxSource=true&fragments=statusLoader",
  });
}

function clickSubmitButton() {
  const submitButton = document.querySelector(
    "button#event"
  ) as HTMLButtonElement;
  submitButton.click();
}
